import { Component } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {BehaviorSubject} from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../auth-client/services/user.service';
import {map} from 'rxjs/operators';
import {ShoppingService} from '../../component/services/shopping.service';
import {FilterService} from '../../component/services/filter.service';

@Component({
    selector: 'brover-root',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.sass'],
    standalone: false
})
export class RootComponent {
  public base_url: String = environment.uploads;

  public opened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isSmall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public imageSrc;
  public userPictureUrl: string;
  public test: boolean;
  public gross_enabled: boolean;
  public gross_enabled_price_change: boolean; //Disables or enables price switch based on given rights.

  constructor(private breakpointObserver: BreakpointObserver, private router: Router, public userService: UserService) {
    this.gross_enabled = false;
    this.gross_enabled_price_change = false;
    this.userService.getMe(true, false, true).subscribe(res => {
      this.gross_enabled_price_change = res['data']['userSettings']['gross_price_rights'];
      if (res['data']['userSettings']['gross_price']) {
        this.gross_enabled = true;
        this.imageSrc = environment.uploads + 'gross_' + res['data']['companies'][0]['company']['image'];
      } else {
        this.imageSrc = environment.uploads + res['data']['companies'][0]['company']['image'];
      }
    });
    this.breakpointObserver.observe('(max-width: 1000px)').pipe(
      map(r => r.matches)).subscribe(result => {
        this.isSmall.next(!result);
      });
  }

  private change(opened: boolean) {
    this.opened.next(opened);
  }

  close() {
    this.change(false);
  }

  open() {
    this.change(true);
  }
}
